<template>
  <FormsFieldsWrapper
    :name="name"
    :label="label"
    :description="description"
    :error="{ message: errorMessage }"
    :success="{
      valid: meta.valid,
      message: successMessage,
    }"
  >
    <div class="flex gap-2">
      <slot name="left" />
      <component
        :is="$slots.prefix || $slots.suffix ? 'InputGroup' : 'div'"
        class="w-full"
      >
        <slot name="prefix" />
        <InputText
          :id="name"
          :name="name"
          :type="type"
          :value="inputValue"
          :placeholder="placeholder"
          :disabled="disabled"
          :class="{ 'p-invalid': errorMessage }"
          aria-describedby="text-error"
          @input="handleChange"
          @blur="handleBlur"
        />
        <slot name="suffix" />
      </component>
      <slot name="right" />
    </div>
  </FormsFieldsWrapper>
</template>

<script setup lang="ts">
import useFormField, { defaultProps } from './useFormField'

const props = defineProps({
  type: { type: String, default: 'text' },
  ...defaultProps,
})

const { name, inputValue, errorMessage, handleBlur, handleChange, meta }
  = useFormField(props)
</script>
